import React from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../../utils/logger';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ApplicationMessages from '../../inAppMessages/ApplicationMessages';
import HighlightOnInAppMessage from '../../inAppMessages/HighlightOninAppMessage';
import _ from 'lodash';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';

let FORM_NAME = 'ADD_LOCALLISTING_LINES';
let log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const AMOUNT_REGEX = /^-?\d*[\.]?\d+$/;

class AddLocalListingLines extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedListingType: '',
            vatNumber: '',
            totalAmount: '',
            amountExclVAT:'',
            amountVAT:''
        };
        this.FORM_NAME_FOR_USER = _.uniqueId('addLocalListingLinesForm_');
        this.onAdd = this.onAdd.bind(this);
        this.onVatNumberChange = this.onVatNumberChange.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);
        log = new Logger(this.FORM_NAME_FOR_USER, LOG_LEVELS.DEBUG);
    }

    onAdd(evt) {
        let isInvalidForm = false;
        //Perform validations
        const vatNumber = this.state.vatNumber;
        if (!vatNumber || vatNumber.trim() === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_VAT_NUMBER);
            isInvalidForm = true;
        }

        //Perform validations
        let totalAmount = this.state.totalAmount || '';
        if(!AMOUNT_REGEX.test(totalAmount)){
            log.setDictionaryMessage(ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNT);
            isInvalidForm = true;
        }

        let totalAmountExclVAT = this.state.amountExclVAT || '';
        if(!AMOUNT_REGEX.test(totalAmountExclVAT)){
            log.setDictionaryMessage(ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNTECLVAT);
            isInvalidForm = true;
        }

        let totalAmountVAT = this.state.amountVAT || '';
        if(!AMOUNT_REGEX.test(totalAmountVAT)){
            log.setDictionaryMessage(ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNTVAT);
            isInvalidForm = true;
        }

        if (!isInvalidForm) {
            const newLine = {
                vatNumber: vatNumber,
                totalAmount: parseFloat(totalAmount === '' ? 0.0 : totalAmount).toFixed(2),
                amountExclVAT: parseFloat(totalAmountExclVAT === '' ? 0.0 : totalAmountExclVAT).toFixed(2),
                amountVAT: parseFloat(totalAmountVAT === '' ? 0.0 : totalAmountVAT).toFixed(2),
                listingLineType : 0
            };
            this.setState({
                selectedListingType: '',
                vatNumber: '',
                totalAmount: '',
                amountExclVAT : '',
                amountVAT : ''
            });
            if(typeof this.props.onAdd === 'function') {
                this.props.onAdd(newLine);
            }
        }
    }

    onVatNumberChange(event) {
        const newValue = event.target.value;
        if(newValue !== this.state.vatNumber) {
            log.clearDictionaryError(ALL_MESSAGES.BLANK_VAT_NUMBER);
            this.setState({
                vatNumber: newValue
            });
        }
    }

    onAmountChange(event) {
        const newValue = event.target.value;
        const fieldType = event.target.id;
        switch (fieldType)
        {
            case 'totalAmount':
                if(newValue !== this.state.totalAmount) {
                    log.clearDictionaryError(ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNT);
                    this.setState({
                        totalAmount: newValue
                    });
                }
                break;
            case 'amountExclVAT':
                if(newValue !== this.state.amountExclVAT) {
                    log.clearDictionaryError(ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNTECLVAT);
                    this.setState({
                        amountExclVAT: newValue
                    });
                }
                break;
            case 'amountVAT':
                if(newValue !== this.state.amountVAT) {
                    log.clearDictionaryError(ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNTVAT);
                    this.setState({
                        amountVAT: newValue
                    });
                }
                break;
        }
    }

    render() {
        return (
            <div>
                <h2 className="mt20">{this.props.title}</h2>
                <s-row>
                    <s-col span="6">
                        <s-box name="form-panel" class="mb15">
                            <fieldset>
                                <ApplicationMessages scopes={[this.FORM_NAME_FOR_USER]} messageType="applicationError"/>
                                <label className="mt0"><LanguageStringResolver string='addListingLines_VATNumber'/></label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.BLANK_VAT_NUMBER]} >
                                    <input id="vatNumber" className="mt10" value={this.state.vatNumber} onChange={this.onVatNumberChange} />
                                </HighlightOnInAppMessage>
                                <label><LanguageStringResolver string='addListingLines_TotalAmount'/></label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNT]} >
                                    <input className={withFullStoryExclude("mt10")} id="totalAmount" value={this.state.totalAmount} onChange={this.onAmountChange} />
                                </HighlightOnInAppMessage>
                                <label><LanguageStringResolver string='addListingLines_TotalAmountExclVAT'/></label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNTECLVAT]} >
                                    <input id="amountExclVAT"  className={withFullStoryExclude("mt10")} value={this.state.amountExclVAT} onChange={this.onAmountChange} />
                                </HighlightOnInAppMessage>
                                <label><LanguageStringResolver string='addListingLines_TotalAmountVAT'/></label>
                                <HighlightOnInAppMessage
                                    scopes={[this.FORM_NAME_FOR_USER]}
                                    messageIds={[ALL_MESSAGES.LOCALLISTING_INVALID_AMOUNTVAT]} >
                                    <input id="amountVAT"  className={withFullStoryExclude("mt10")} value={this.state.amountVAT} onChange={this.onAmountChange} />
                                </HighlightOnInAppMessage>
                                <button className="secondary mt20"
                                        onClick={this.onAdd}>
                                    <LanguageStringResolver string='localListingLines_AddNewListingLine'/>
                                </button>
                            </fieldset>
                        </s-box>
                    </s-col>
                </s-row>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps: ', state);
    //const formNameForUser = FORM_NAME + '_FOR_' + (props.user !== undefined ? props.user.email : 'LoggedOut');
    return {
        languages: state.languages
        //FORM_NAME_FOR_USER: formNameForUser
    };
}

function mapDispatchersToProps(dispatch) {
    return {
    }
}


AddLocalListingLines.defaultProps = {
    onAdd: () => { },
    ecTypes: [],
    title: ''
}

export default connect(mapStateToProps, mapDispatchersToProps)(AddLocalListingLines);
